import React from 'react';
import styles from '../../styles/components/Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <nav>
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Service</a>
      </nav>
      <p>Nana + Cece &copy; 2024-Present. All rights reserved.</p>
    </footer>
  );
}

export default Footer;